import(/* webpackMode: "eager" */ "/app/src/components/Contact.tsx")